import { render, staticRenderFns } from "./proList3.vue?vue&type=template&id=24dde27c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\webstorm_space\\clean_data_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24dde27c')) {
      api.createRecord('24dde27c', component.options)
    } else {
      api.reload('24dde27c', component.options)
    }
    module.hot.accept("./proList3.vue?vue&type=template&id=24dde27c&", function () {
      api.rerender('24dde27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/proList3.vue"
export default component.exports